import angular from 'angular';
import uiRouter from 'angular-ui-router';
import ScaComponent from './sca.component';

const scaModule = angular.module('tinaba.components.sca', [
  uiRouter
])

// .config(($stateProvider) => {
//   'ngInject';
//
//   $stateProvider
//     .state('login', {
//       url: '/login',
//       template: '<login></login>'
//     });
// })

.component('sca', ScaComponent);

export default scaModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/sca/sca.js
 **/